export const iconFontAwesomeCommunicationInbox = (
	<i className="fa-solid fa-inbox"></i>
);
